import React from 'react';
import styles from './ContentLinkWithReminder.module.scss';
import { SFIcon } from 'sfui';
import {
  InteractiveBox,
  ReminderTooltip,
  ReminderTooltipType
} from 'ui-smartforce-settings';
import { SFNavContentLinkProps } from '../SFNavContentLink/SFNavContentLink';

export interface ContentLinkWithReminderProps extends SFNavContentLinkProps {
  isCollapsed?: boolean;
  tooltipProps: {
    open: boolean;
    type: ReminderTooltipType;
    onGotIt: (type: ReminderTooltipType, checked: boolean) => void;
  };
}

const ContentLinkWithReminder = ({
  isCollapsed = false,
  link,
  disabled = false,
  tooltipProps,
  onDrawerClose
}: ContentLinkWithReminderProps): React.ReactElement<ContentLinkWithReminderProps> => {
  const onClick = () => {
    link.onClick && link.onClick();
    onDrawerClose && onDrawerClose();
  };

  return (
    <div
      className={`${styles.linkContainer} ${disabled ? styles.disabled : ''}`}
    >
      <InteractiveBox className={styles.link} onClick={onClick}>
        {isCollapsed && (
          <ReminderTooltip
            type={tooltipProps.type}
            open={tooltipProps.open}
            onGotIt={tooltipProps.onGotIt}
            style={{
              marginLeft: '12px'
            }}
          >
            <SFIcon
              icon={link.icon as string}
              className={styles.icon}
              size={20}
            />
          </ReminderTooltip>
        )}

        {!isCollapsed && (
          <>
            <SFIcon
              icon={link.icon as string}
              className={styles.icon}
              size={20}
            />
            <ReminderTooltip
              type={tooltipProps.type}
              open={tooltipProps.open}
              onGotIt={tooltipProps.onGotIt}
              style={{
                marginLeft: '12px'
              }}
            >
              <div className={styles.linkContent}>
                <span className={styles.text}>{link.label}</span>
              </div>
            </ReminderTooltip>
          </>
        )}
      </InteractiveBox>
    </div>
  );
};

export default ContentLinkWithReminder;
